import { QuestionModel } from '@/survey/logic/QuestionModel';
import { action } from 'mobx';

export class TextModel extends QuestionModel {
  @action
  set_userComment(this: TextModel, userComment: string) {
    super.set_userComment(userComment);

    if (this.userComment && !this.selectedAnswers.length && this.question.form_answers[0]) {
      this.set_selectedAnswers([this.question.form_answers[0]]);
      return;
    }

    // Этот тип вопроса может быть необязательным, поэтому если комментарий пустой, то ответ надо удалить.
    if (!this.userComment && this.selectedAnswers.length) {
      this.set_selectedAnswers([]);
      return;
    }
  }

  @action
  validateAnswers() {
    this.validationErrors.emptyUserCommentError = this.question.is_required && !this.userComment;

    super.throwIfInvalid();
  }
}
